import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {Space} from 'antd';
import {
  StyledTableFilters,
  StyledTableFiltersSearch,
  StyledTableFiltersSelect,
  StyledTableFiltersElements,
  StyledRightSideContent
} from './StyledTableFilters';
import {userGroupConstants} from '../../../../../constants';


const TableFilters = ({
  dispatch,
  onFilter,
  rightSideContent,
  teamTags,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'teams']);
  const [filter, setFilter] = useState({
    search: '',
    team_id: undefined,
    user_group: userGroupConstants.ALL
  });

  const viewOptionTranslation = (key) => t(`teams:viewOptions.${key}`);

  const userGroupOptions = [
    {label: viewOptionTranslation('all'), value: userGroupConstants.ALL},
    {label: viewOptionTranslation('internal'), value: userGroupConstants.ACTIVE},
    {label: viewOptionTranslation('external'), value: userGroupConstants.EXTERNAL},
    {label: viewOptionTranslation('disabled'), value: userGroupConstants.DISABLED},
  ];

  const teamOptions = useMemo(() => teamTags.map(tag => ({label: tag.tag_name, value: tag.id})), [teamTags]);

  const handleOnFilter = (key, value) => {
    setFilter({...filter, [key]: value});
    onFilter?.({[key]: value});
  }

  return (
    <StyledTableFilters {...rest}>
      <StyledTableFiltersElements>
        <Space size='small'>
          <StyledTableFiltersSearch
            allowClear
            onSearch={(value) => handleOnFilter('search', value)}
            placeholder={t('search')}
            size='large'
            value={filter.search}
          />
          <StyledTableFiltersSelect
            onChange={(value) => handleOnFilter('user_group', value)}
            options={userGroupOptions}
            value={filter.user_group}
            size='large'
          />
          <StyledTableFiltersSelect
            allowClear
            onChange={(value) => handleOnFilter('team_id', value)}
            options={teamOptions}
            placeholder={t('team')}
            value={filter.team_id}
            size='large'
          />
        </Space>

        {rightSideContent && <StyledRightSideContent>{rightSideContent}</StyledRightSideContent>}
      </StyledTableFiltersElements>
    </StyledTableFilters>
  );
}

TableFilters.propTypes = {
  onFilter: PropTypes.func,
  rightSideContent: PropTypes.any
}

const mapStateToProps = ({ company: { teamTags } }) => ({
  teamTags,
});

export default connect(mapStateToProps, null)(TableFilters);
